import { render, staticRenderFns } from "./readFree.vue?vue&type=template&id=1dcd72f7&scoped=true&"
import script from "./readFree.vue?vue&type=script&lang=js&"
export * from "./readFree.vue?vue&type=script&lang=js&"
import style0 from "./readFree.vue?vue&type=style&index=0&id=1dcd72f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd72f7",
  null
  
)

export default component.exports